import React            from 'react';

import SolutionGrid     from './SolutionGrid';
import BoxGrid          from './BoxGrid';
import TargetContainer  from './TargetContainer';
import Ghost            from './Ghost';
import EggGhost         from './EggGhost';
import ButtonContainer  from './ButtonContainer';
import HelpModal        from './HelpModal';
import NextLevelButton  from './NextLevelButton';

import Pyrotechnics     from '../../components/Pyrotechnics';
import OptionMenu       from '../../components/OptionMenu';

import LevelButtons     from './LevelButtons';
import HelpButton       from '../../components/HelpButton';
import BigProgressBar   from '../../components/progress_bar/Big';
import SmallProgressBar from '../../components/progress_bar/Small';

import tests            from './tests';
import { makeStyles }   from '@material-ui/core/styles';


const dragHere = `גררו תבניות ביצים לכאן`;
const tooManyEggs = `נכון! נסו לסמן את כמות הביצים הנכונה`;
const tooManyfailures = `נכון!`;
const greatSuccess = `כל הכבוד!`;


const useStyles = makeStyles(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        transition:      'opacity 0.3s'
    },
    pyrotechnics: {
      position:        'fixed',
      width:           '100vw',
      height:          '100vh',
      backgroundColor: 'rgba(0,0,0,0.5)',
      transition:      'all 1s',
      zIndex:          2
    },
}))

type ExercisesProps = {
    size:           number[];
    wideScreen:     boolean;
    handleNavigate: (val: string) => void;
}

const Exercises: React.FC<ExercisesProps> = ({ size, wideScreen, handleNavigate }) => {

  const classes = useStyles();


  const [opacity, setOpacity]                             = React.useState(1)
  const [testNum, setTestNum]                             = React.useState(0)
  const [level, setLevel]                                 = React.useState(0)
  const [testArr, setTestArr]                             = React.useState(tests)
  const [correctValues, setCorrectValues]                 = React.useState([testArr[0][0][0], testArr[0][0][1]])
  const [answer, setAnswer]                               = React.useState(testArr[0][0][0] + testArr[0][0][1])
  const [ghost, setGhost]                                 = React.useState(false)
  const [eggGhost, setEggGhost]                           = React.useState(false)
  const [ghostPosition, setGhostPosition]                 = React.useState([] as number[])
  const [ghostValue, setGhostValue]                       = React.useState(0)
  const [target0Value, setTarget0Value]                   = React.useState(0)
  const [target1Value, setTarget1Value]                   = React.useState(0)
  const [target0Hover, setTarget0Hover]                   = React.useState(false)
  const [target1Hover, setTarget1Hover]                   = React.useState(false)
  const [reception0, setReception0]                       = React.useState(false)
  const [reception1, setReception1]                       = React.useState(false)
  const [putEggBackInBox, setPutEggBackInBox]             = React.useState(false)
  const [draggedEgg, setDraggedEgg]                       = React.useState(-1)
  const [showFinalValue, setShowFinalValue]               = React.useState(false)
  const [selectableEggs, setSelectableEggs]               = React.useState(0)
  const [selectedEggs, setSelectedEggs]                   = React.useState(0)
  const [selectedEggsArr, setSelectedEggsArr]             = React.useState([] as number[])
  const [disabledEggsArr, setDisabledEggsArr]             = React.useState([] as number[])
  const [transferedEggs, setTransferedEggs]               = React.useState(0)
  const [maxSelections, setMaxSelections]                 = React.useState(9)
  const [failureCounter, setFailureCounter]               = React.useState(0)
  const [dragOrSelect, setDragOrSelect]                   = React.useState('')
  const [eggIndex, setEggIndex]                           = React.useState(0)
  const [showHelpModal, setShowHelpModal]                 = React.useState(false)
  const [eggOverflow, setEggOverflow]                     = React.useState(false)
  const [progLength, setProgLength]                       = React.useState(testArr[level].length - 1)
  const [prog, setProg]                                   = React.useState(0)
  const [showPyrotechnics, setShowPyrotechnics]           = React.useState(false)
  const [showOptionMenu, setShowOptionMenu]               = React.useState(false)
  const [rejectEggBox, setRejectEggBox]                   = React.useState(false)
  const [showClearButton, setShowClearButton]             = React.useState(false)
  const [message, setMessage]                             = React.useState(dragHere)
  const [showContinueButton, setShowContinueButton]       = React.useState(false)
  const [showAnswer, setShowAnswer]                       = React.useState(false)
  const [showUndo, setShowUndo]                           = React.useState(true)
  const [valuesSet, setValuesSet]                         = React.useState(false)
  const [showArrangementButton, setShowArrangementButton] = React.useState(false)
  const [closeAtTen, setCloseAtTen]                       = React.useState(false)
  const [showErr, setShowErr]                             = React.useState(false)  
  


  React.useEffect(() => {
     if (!valuesSet && target0Value && target1Value) {
        setCorrectValues([target0Value, target1Value])
        setValuesSet(true)
     }
  },[valuesSet, target0Value, target1Value])
  

  React.useEffect(() => {
   if(target0Value === 10 || target1Value === 10 ) {
      setShowArrangementButton(true)
   }
  },[target0Value, target1Value])

  
  React.useEffect(() => {

     if (target0Value && target1Value && !showClearButton) {
        setShowClearButton(true)
     }

  },[target0Value, target1Value, showClearButton])



  React.useEffect(() => {
     if (selectableEggs === 2) {
        if (target0Value < target1Value) {
           setSelectableEggs(0)
        }
        if (target1Value < target0Value) {
           setSelectableEggs(1)
      }
     }
  },[target0Value, target1Value, selectableEggs])

  React.useEffect(() => {
   if ((!target0Value && !target1Value) || (testArr[level][testNum][0] === testArr[level][testNum][1])) {
      if ((target0Hover || target1Hover) && ( ghostValue !== testArr[level][testNum][0] ) && ( ghostValue !== testArr[level][testNum][1] )) {
       setRejectEggBox(true)
      }
    } 
   else if ((target1Value === testArr[level][testNum][1] && target0Hover && (ghostValue !== testArr[level][testNum][0]))
           ||
           (target1Value === testArr[level][testNum][0] && target0Hover && (ghostValue !== testArr[level][testNum][1]))
           ||
           (target0Value === testArr[level][testNum][1] && target1Hover && (ghostValue !== testArr[level][testNum][0]))
           ||
           (target0Value === testArr[level][testNum][0] && target1Hover && (ghostValue !== testArr[level][testNum][1]))
           ){
            setRejectEggBox(true)
      }
   else {
     setRejectEggBox(false)
   }
  },[ghostValue, testArr, level, testNum, target0Hover, target1Hover, target0Value, target1Value])


  const ghostShake = React.useMemo(() => {
   return (rejectEggBox && (target0Hover || target1Hover))
          
  },[rejectEggBox, target0Hover, target1Hover])



  React.useEffect(() => {
      if (!testArr[level] || !testArr[level][testNum]) {
         return
      }
      setCorrectValues([testArr[level][testNum][0], testArr[level][testNum][1]])
  },[level, testNum, testArr])
  

  React.useEffect(() => {
    if (target0Value > target1Value) {
      setSelectableEggs(1)
    }
    if (target0Value < target1Value) {
      setSelectableEggs(0)
    }
    if (target0Value === target1Value) {
      setSelectableEggs(2)
    }
    setMaxSelections(10 - Math.max(target0Value, target1Value))

  },[target0Value, target1Value/* , testArr, level, testNum */])

  const [
        egg_h, 
        egg_w,
        box_h, 
        box_w, 
        target_size, 
        target_top, 
        target_bottom, 
        target0_left, 
        target0_right, 
        target1_left, 
        target1_right,
        egg_target_top,
        egg_target_bottom,
        egg_target0_left,
        egg_target0_right,
        egg_target1_left,
        egg_target1_right
      ] = React.useMemo(() => {
      
      const eggH        = 65
      const eggW        = 35

      const boxW        = wideScreen ? 250 : 150;
      const boxH        = wideScreen ? 90 : 40;

      const targetS     = (size[0] > 950 && size[1] > 700) ? 350 : wideScreen ? 250 : 150;
      const targetT     = size[1]/2 - targetS/4 - boxH/2;
      const targetB     = size[1]/2 + targetS/4 - boxH/2;
      const target0L    = size[0]/2 - targetS - boxW/2;
      const target0R    = size[0]/2 - boxW/2;
      const target1L    = size[0]/2 - boxW/2;
      const target1R    = size[0]/2 + targetS - boxW/2;

      const eggTargetT  = size[1]/2 - targetS/4 - eggH/2;
      const eggTargetB  = size[1]/2 + targetS/4 - eggH/2;
      const eggTarget0L = size[0]/2 - targetS - eggW/2;
      const eggTarget0R = size[0]/2 - eggW/2;
      const eggTarget1L = size[0]/2 - eggW/2;
      const eggTarget1R = size[0]/2 + targetS - eggW/2;

      return[
         eggH, 
         eggW, 
         boxH, 
         boxW, 
         targetS, 
         targetT, 
         targetB, 
         target0L, 
         target0R, 
         target1L, 
         target1R,
         eggTargetT,
         eggTargetB,
         eggTarget0L,
         eggTarget0R,
         eggTarget1L,
         eggTarget1R,
      ];

},[size, wideScreen])


  const lastTest = React.useMemo(() => {
     return level === 2 && testNum === testArr[level].length - 1
  },[level, testNum, testArr])


  const showUndoButton = React.useMemo(() => {
   return (
            showUndo
            &&
            (target0Value > 0 && target0Value !== correctValues[0]) 
            && 
            (target1Value > 0 && target1Value !== correctValues[1])
         )
 },[target0Value, target1Value, correctValues, showUndo])

  
 const arrange = () => {
    setShowUndo(false)
    setShowArrangementButton(false)
    setShowErr(false)
    setTimeout(() => {
       setCloseAtTen(true)
       setShowFinalValue(true)
       setSelectedEggsArr([])
       setDisabledEggsArr([])
       setTransferedEggs(0)
    },1000)
    setTimeout(() => {
       setShowUndo(true)
    },2000) 
 }


  const do_reception = (x: number, y: number) => {

    const [L_0, R_0, L_1, R_1, T_, B_] = eggGhost 
          ? 
          [egg_target0_left, egg_target0_right, egg_target1_left, egg_target1_right, egg_target_top, egg_target_bottom]
          :
          [target0_left, target0_right, target1_left, target1_right, target_top, target_bottom];

    setGhostPosition([x, y]);
    if ( x > L_0 && x < R_0 && y > T_ && y < B_) {
      setTarget0Hover(true);
    }
    else {
      setTarget0Hover(false);
    }
    if ( x > L_1 && x < R_1 && y > T_ && y < B_) {
      setTarget1Hover(true);
    }
    else {
      setTarget1Hover(false);
    }
  }

  const handleMouseDown = (e: React.MouseEvent, ind: number) => {
     
     e.preventDefault();

     setShowErr(false)

     if (ind < 0) {

       setShowFinalValue(false)
       setPutEggBackInBox(false)

       if (ind > -200) {
           if (!target0Value || target1Value === 10) {
              return
           }
           setDraggedEgg((ind * -1) - 100)
           setEggIndex(-1)
           setTarget0Hover(true)
       }
       if (ind <= -200) {
           if (!target1Value || target0Value === 10) {
              return
           }
           setDraggedEgg((ind * -1) - 200)
           setEggIndex(-2)
           setTarget1Hover(true)
       }
       setEggGhost(true)
       setGhostPosition([e.pageX - egg_w / 2, e.pageY - egg_h / 2]);
     }
     else {
      setGhost(true)
      setGhostValue(ind + 1)
      setGhostPosition([e.pageX - box_w / 2, e.pageY - box_h / 2]);
     }
  }

  const handleTouchStart = (e: React.TouchEvent, ind: number) => {

     setShowErr(false)

     if (ind < 0) {
      setShowFinalValue(false)
      setPutEggBackInBox(false)
      if (ind > -200) {
         if (!target0Value || target1Value === 10) {
            return
         }
         setEggIndex(-1)
         setTarget0Hover(true)
         //setTarget0Value(target0Value - 1)
      }
      if (ind <= -200) {
         if (!target0Value || target1Value === 10) {
            return
         }
         setEggIndex(-2)
         setTarget1Hover(true)
         //setTarget0Value(target1Value - 1)
      }
      setEggGhost(true)
      setGhostPosition([e.touches[0].pageX - egg_w / 2, e.touches[0].pageY - egg_h / 2]);
     }
     else {
      setGhost(true);
      setGhostValue(ind + 1)
      setGhostPosition([e.touches[0].pageX - box_w / 2, e.touches[0].pageY - box_h / 2]);
     }
  }

  const handleMouseMove = (e: React.MouseEvent) => {
     e.preventDefault();
     if (!ghost && !eggGhost) { return }
     if (ghost) { 
        const x_ = e.pageX - box_w/2;
        const y_ = e.pageY - box_h/2;
        do_reception(x_, y_);
     }
     if (eggGhost) {
        const x_ = e.pageX - egg_w/2;
        const y_ = e.pageY - egg_h/2;
        do_reception(x_, y_);
     }     
  }

  const handleTouchMove = (e: React.TouchEvent ) => {
     if (!ghost && !eggGhost) { return }
     if (ghost) { 
        const x_ = e.touches[0].pageX - box_w/2;
        const y_ = e.touches[0].pageY - box_h/2;
        do_reception(x_, y_);
     }
     if (eggGhost) {
        const x_ = e.touches[0].pageX - egg_w/2;
        const y_ = e.touches[0].pageY - egg_h/2;
        do_reception(x_, y_);
     }     
  }

  const handleMouseUp = () => {

   //setMouseUp(true)

   if (ghost && rejectEggBox) {
      setRejectEggBox(false)
      setTarget0Hover(false)
      setTarget1Hover(false)
      setGhost(false)
     // setEggGhost(false)
      return
   }
    if (target0Hover) {
       if (ghost) {
         setTarget0Hover(false)
         setReception0(true)
         setTarget0Value(ghostValue)
         setSelectedEggs(0)
       }
       if (eggGhost) {
         setTarget0Hover(false)
         if (eggIndex === -2) {
            setTarget0Value(target0Value + 1)
            setTarget1Value(target1Value - 1)
            setPutEggBackInBox(false)
         }
         else {
            setPutEggBackInBox(true)
         }
       }
    }
    if (target1Hover) {
       if (ghost) {
         setTarget1Hover(false)
         setReception1(true)
         setTarget1Value(ghostValue)
         setSelectedEggs(0)
       }
       if (eggGhost) {
         setTarget1Hover(false)
         if (eggIndex === -1) {
            setTarget1Value(target1Value + 1)
            setTarget0Value(target0Value - 1)
            setPutEggBackInBox(false)
         }
         else {
            setPutEggBackInBox(true)
         }
       }
    }
    if (eggGhost && !target1Hover && !target0Hover) {
       setPutEggBackInBox(true)
    } 
    if (ghost || eggGhost) { 
       setGhostPosition([0,0]);
       setGhost(false) 
       setEggGhost(false)
       setEggIndex(0)
    }
  }

  const reset = () => {
   setDragOrSelect('')
   setFailureCounter(0)
   setSelectedEggs(0)
   setTransferedEggs(0)
   setTarget0Value(0)
   setTarget1Value(0)
   setReception0(false)
   setReception1(false)
   setEggOverflow(false)
   setShowClearButton(false)
   setShowContinueButton(false)
   setMessage(dragHere)
   setShowAnswer(false)
   setShowFinalValue(false)
   setValuesSet(false)
   setOpacity(1)
   setSelectedEggsArr([])
   setDisabledEggsArr([])
   setShowArrangementButton(false)
   setCloseAtTen(false)
  }

  const handleGoToNextLevel = () => {
     if (level === 2) {
        return
     }
      setOpacity(0)
      setTimeout(() => {
         setTestNum(0);
         setAnswer(testArr[level + 1][0][0] + testArr[level + 1][0][1])
         setLevel(level + 1);
         setProg(0)
         setProgLength(testArr[level + 1].length - 1)
         setOpacity(1)
         reset()
      },300)
  }


  const failTest = () => {
      setOpacity(0)
      setTimeout(() => {
         let newTestArr = testArr.slice();
         const current = newTestArr[level][testNum]
         newTestArr[level].push(current)
         setTestArr(newTestArr)
         setAnswer(newTestArr[level][testNum + 1][0] + newTestArr[level][testNum + 1][1])
         setCorrectValues([testArr[level][testNum + 1][0], testArr[level][testNum + 1][1]])
         setTestNum(testNum + 1)
         reset()
         setOpacity(1)
      },300)
  }


  const passTest = () => {
   setOpacity(0)
   if (testNum < testArr[level].length - 1) {
      setTimeout(() => {
         setAnswer(testArr[level][testNum + 1][0] + testArr[level][testNum + 1][1])
         setProg(prog + 1)
         setTestNum(testNum + 1)
         reset()
         setOpacity(1)
      },300)
   } else if (level < 2) {
      setTimeout(() => {
         setAnswer(testArr[level + 1][0][0] + testArr[level + 1][0][1])
         setCorrectValues([testArr[level + 1][0][0], testArr[level + 1][0][1]])
         setLevel(level + 1);
         setTestNum(0)
         setProgLength(testArr[level + 1].length - 1)
         setProg(0)
         setOpacity(1)
         reset()
      },300)
   } else {
      setShowPyrotechnics(true)
      setTimeout(() => {
         setShowOptionMenu(true)
      },10000)
   }
}


  const handleSolutionClick = (val: number) => {

       if (testArr[level][testNum][0] + testArr[level][testNum][1] === val) {
         
               setTarget0Value(0)
               setTarget1Value(0) 
               setShowContinueButton(true)

               if (eggOverflow) {
                  setMessage(tooManyEggs)
                  setShowErr(true)
               }
               else if (failureCounter) {
                  setMessage(tooManyfailures)
                  setShowErr(true)
               }
               else {
                  setShowAnswer(true)
                  setMessage(greatSuccess)
                  setShowErr(false)
               }
      } else {
              if (answer < 10 && showClearButton && failureCounter >= 1) {
                 setTimeout(() => {
                  setShowFinalValue(true)
                  setSelectedEggsArr([])
                  setDisabledEggsArr([])
                  setTransferedEggs(0)
                  setTarget1Value(answer >= 10 ? answer - 10 : 0)
                  setTarget0Value(answer >= 10 ? 10 : answer)
                 },1500)
              } 
              if (failureCounter < 2) {
                 setShowErr(true)
                 setFailureCounter(failureCounter + 1)
              }
      }
  }


  const handleEggSelection = (ind: number, counter: number, val: number) => {

     setShowFinalValue(false)

     if (counter === -2) {
        if (selectedEggsArr.includes(val)) {
           const newSelectedEggsArr = selectedEggsArr.slice();
           newSelectedEggsArr.splice(newSelectedEggsArr.indexOf(val), 1);
           setSelectedEggsArr(newSelectedEggsArr)
           setSelectedEggs(newSelectedEggsArr.length)
        }
     }
     if (!eggOverflow && counter === -1) {        
      setEggOverflow(true)
      return;
     }
     else {
        if (counter > 0) {
         
          // setSelectedEggs(counter - transferedEggs)
           if (!selectedEggsArr.includes(val)) {
              const newSelectedEggsArr = selectedEggsArr.slice();
              newSelectedEggsArr.push(val);
              setSelectedEggsArr(newSelectedEggsArr)
              setSelectedEggs(newSelectedEggsArr.length)
           }
        }
     }
     if (selectableEggs === 2) {
        if (ind === -1) {
           setSelectableEggs(0)
        }
        if (ind === -2) {
           setSelectableEggs(1)
        }
     }
  }

  const transferEggs = () => {
     if (selectableEggs === 0) {
        setTarget0Value(target0Value - selectedEggs)
        setTarget1Value(target1Value + selectedEggs)
     }
     if (selectableEggs === 1) {
        setTarget1Value(target1Value - selectedEggs)
        setTarget0Value(target0Value + selectedEggs)
     }
     
     setTransferedEggs(selectedEggs)
     setDisabledEggsArr(disabledEggsArr.concat(selectedEggsArr))
     setSelectedEggs(0)
     setSelectedEggsArr([])
  }


  const handleDragButtonClick = () => {
     setDragOrSelect('drag')
     setSelectedEggs(0)
  }


  const handleHelpClick = () => {
   setShowHelpModal(!showHelpModal)
  }


  const handleRejectEggBox = () => {
   setRejectEggBox(true)
}

  const handleMenuClick = (val: number) => {
     if (!val) {
      setTestArr(tests)
      setTestNum(0)
      setLevel(0)
      setShowPyrotechnics(false)
      setShowOptionMenu(false)
      setProg(0)
      setProgLength(testArr[0].length - 1)
      setCorrectValues([testArr[0][0][0], testArr[0][0][1]])
      setAnswer(testArr[0][0][0] + testArr[0][0][1])
      reset()
     }
     else {
        handleNavigate('menu')
     }
  }

  const unDo = () => {
   setMaxSelections(9)
   setSelectedEggs(0)
   setTransferedEggs(0)
   setTarget0Value(correctValues[0])
   setTarget1Value(correctValues[1])
   setSelectedEggsArr([])
   setDisabledEggsArr([])
   setDraggedEgg(-1)  
   setShowFinalValue(true)
   setShowAnswer(false)
   setFailureCounter(0)
   setMessage('')
   setShowArrangementButton(false)
   setCloseAtTen(false)
  }

  return (
     <div 
        className     = { classes.root }
        onMouseMove   = { handleMouseMove }
        onTouchMove   = { handleTouchMove }
        onMouseUp     = { handleMouseUp }
        onTouchEnd    = { handleMouseUp }
        onTouchCancel = { handleMouseUp }
     >
        <NextLevelButton
           level               = { level }
           handleGoToNextLevel = { handleGoToNextLevel }
        />
        <ButtonContainer
           size                  = { size }
           wideScreen            = { wideScreen }
           target_size           = { target_size }
           target0Value          = { target0Value }
           target1Value          = { target1Value }
           selectedEggs          = { selectedEggs }
           dragOrSelect          = { dragOrSelect }
           opacity               = { opacity }
           showContinueButton    = { showContinueButton }
           correctValues         = { [testArr[level][testNum][0], testArr[level][testNum][1]] }
           transferEggs          = { transferEggs }
           setDragOrSelect       = { setDragOrSelect }
           handleDragButtonClick = { handleDragButtonClick }
        />
      {/*   <ClearButton
           showClearButton    = { showClearButton }
           showContinueButton = { showContinueButton }
           handleClick        = { eggOverflow || failureCounter ? failTest : showContinueButton ? passTest : clear }
        /> */}
        <BoxGrid
           size               = { size }
           correctValues      = { correctValues }
           variant            = { 0 }
           showClearButton    = { showClearButton || showContinueButton }
           handleRejectEggBox = { handleRejectEggBox }
           handleMouseDown    = { handleMouseDown }
           handleTouchStart   = { handleTouchStart }
        />
        <BoxGrid
           size               = { size }
           correctValues      = { correctValues }
           variant            = { 1 }
           showClearButton    = { showClearButton || showContinueButton }
           handleRejectEggBox = { handleRejectEggBox }
           handleMouseDown    = { handleMouseDown }
           handleTouchStart   = { handleTouchStart }
        />
        <TargetContainer
            wideScreen            = { wideScreen }
            target_size           = { target_size }
            target0Hover          = { target0Hover }
            target1Hover          = { target1Hover }
            target0Value          = { target0Value }
            target1Value          = { target1Value }
            reception0            = { reception0 }
            reception1            = { reception1 }
            selectableEggs        = { selectableEggs }
            selectedEggs          = { selectedEggs }
            transferedEggs        = { transferedEggs }
            maxSelections         = { maxSelections }
            dragOrSelect          = { dragOrSelect }
            eggGhost              = { eggGhost }
            correctValues         = { correctValues }
            opacity               = { opacity }
            ghostShake            = { ghostShake }
            message               = { message }
            showArrangementButton = { showArrangementButton }
            closeAtTen            = { closeAtTen }
            failureCounter        = { failureCounter }
            showFinalValue        = { showFinalValue }
            draggedEgg            = { draggedEgg }
            putEggBackInBox       = { putEggBackInBox }
            disabledEggsArr       = { disabledEggsArr } ///////
            showContinueButton    = { showContinueButton }
            stage1Complete        = { showClearButton }
           // handleButtonClick     = { eggOverflow || failureCounter ? failTest : showContinueButton ? passTest : clear }
            handleButtonClick     = { eggOverflow || failureCounter ? failTest : passTest }
            showErr               = { showErr }
            arrange               = { arrange }
            handleEggSelection    = { handleEggSelection }
            handleMouseDown       = { handleMouseDown }
            handleTouchStart      = { handleTouchStart }
        />
        <SolutionGrid
           size           = { size }
           level          = { level }
           answer         = { answer }
           target_size    = { target_size }
           failureCounter = { failureCounter }
           showAnswer     = { showAnswer }
           handleClick    = { handleSolutionClick }
        />
        <Ghost
          position    = { ghostPosition } 
          shake       = { ghostShake }
          width       = { box_w } 
          height      = { box_h }
          ghostValue  = { ghostValue }
          wideScreen  = { wideScreen }
          ghost       = { ghost }
        />
        <EggGhost
          eggGhost    = { eggGhost }
          position    = { ghostPosition } 
          width       = { egg_w } 
          height      = { egg_h }
        />
        {
            size[0] > 900 && size[1] > 680
            &&
           <BigProgressBar
              size   = { size }
              length = { progLength }
              prog   = { prog }
           />
        }
        {
            (size[0] <= 900 || size[1] <= 680)
            &&
           <SmallProgressBar
              length = { progLength }
              prog   = { prog }
           />
        }
        <HelpButton
            onClick = { handleHelpClick }
        />
        <HelpModal
           showHelpModal    = { showHelpModal }
           setShowHelpModal = { setShowHelpModal }
        />
        <LevelButtons
           level                = { level }
           lastTest             = { lastTest } 
           showUndoButton       = { showUndoButton }
           unDo                 = { unDo}
           handleGoToNextTest   = { failTest } 
           handleGoToNextLevel  = { handleGoToNextLevel }
        />
        {
           showPyrotechnics
           &&
           <div 
               className = { classes.pyrotechnics }
                  
               >
                  {
                    Array(20).fill(0).map((val, ind) => {
                      return(
                        <div key = { `pyrotechics_exercises${ind}` }>
                            <Pyrotechnics 
                              size           = { size } 
                              showOptionMenu = { showOptionMenu }
                              num            = { Math.round(Math.random() * 6) }
                            />
                        </div>
                      )
                    })
               }
           </div>
        }
        <OptionMenu 
           showOptionMenu = { showOptionMenu }
           handleClick    = { handleMenuClick }
        />
     </div>
  );
}



export default Exercises;








